/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import Modal, { IModalProps, ModalSizes } from "@atg/icf-react-components/components/Modal";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RequestStatus } from "~/constants";
import TwoFactorAuthEmailSent from "~/features/auth/components/TwoFactorAuthDialog/TwoFactorAuthEmailSent";
import TwoFactorAuthRequired from "~/features/auth/components/TwoFactorAuthDialog/TwoFactorAuthRequired";
import { selectTwoFactorAuthEmailStatus } from "~/features/auth/selectors";
import { AuthActions } from "~/features/auth/slice";
import { AppDispatch } from "~/state/types";

const TwoFactorAuthDialog: FC<IModalProps> = ({ ...rest }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const emailStatus = useSelector(selectTwoFactorAuthEmailStatus) as RequestStatus;

  const onClose = () => {
    dispatch(AuthActions.reset2FAState());
    navigate("/app/dashboard", { replace: true });
  };

  return (
    <Modal
      open={true}
      onClose={onClose}
      data-ta-locator="twoFactorAuthDialog"
      width="640"
      padding="o"
      size={ModalSizes.medium}
      {...rest}
    >
      {emailStatus === RequestStatus.SUCCESS ? <TwoFactorAuthEmailSent /> : <TwoFactorAuthRequired />}
    </Modal>
  );
};

export default TwoFactorAuthDialog;
